import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export enum SortTypeEnum {
  DefaultSort = 0,
  CollectSort = 1,
  CollectReverseSort = 2,
  PriceSort = 3,
  PriceReverseSort = 4,
  QuantitySort = 5,
  QuantityReverseSort = 6,
}
export enum CataLogStatusEnum {
  GiftWallStatusOffline = -1, // 礼物未上线
  GiftWallStatusUnlight = 0, // 未点亮
  GiftWallStatusCollecting = 1, // 收集中
  GiftWallStatusSuccess = 2, // 已集齐
}
export enum CataLogWearStatusEnum {
  未获得 = -1,
  已获得未穿戴 = 0,
  穿戴中 = 1,
}
export enum PageStatusEnum {
  主态 = 0,
  客态 = 1,
}

export async function uploadImg(params) {
  const resp = await http.post('/live/misc/upload_img', {
    ...params,
    ...window.store.getState().env.deviceinfo,
  })
  return resp.data.data
}

export async function get_gift_catalog_detail(params: {
  mid?: number
  catalog_id?: number
  gift_id?: number
}) {
  const res = await http.post('/live/gift/gift_catalog_detail', {
    ...window.store.getState().env.deviceinfo,
    ...params,
  })
  return res.data.data
}

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=138980764
export const homepage = createAsyncThunk(
  '/live/gift/gift_catalog_homepage',
  async (
    params: {
      mid?: number
      catalog_id?: number
      sort_type?: SortTypeEnum
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/gift/gift_catalog_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...params,
      }
    )
    return resp.data.data
  }
)

export interface GiftWallItemProps {
  gift_id: number
  gift_name: string
  gift_icon: string
  gift_cost: number // 礼物单价
  star_cnt: number // 星星数
  star_limit: number // 星星数上限
  naming_mid: number // 冠名者
  naming_avatar: string // 冠名头像
  status: CataLogStatusEnum
  gift_level: number // 礼物等级
  gift_level_icon: string // 礼物等级icon
  background: string // 礼物背景
  gift_cnt: number // 礼物数
  gift_limit: number // 礼物数上限
  base_gift_cnt: number // 每送出多少礼物可以集星
  base_star_cnt: number // 每次集多少颗星
}
export interface GiftNameplateItemProps {
  nameplate_id?: number // 身份id
  wear?: CataLogWearStatusEnum // 穿戴状态
  star_medal?: string // 身份勋章
  nameplate_bg?: string // 铭牌
  nameplate_text_map?: any // 铭牌文案
  nameplate_text_color?: Array<string> // 铭牌颜色
}

export interface InitialStateType {
  home: {
    member?: {
      mid: number
      name: string
      avatar: string
    }
    is_mystery?: boolean // 当前用户是否是神秘人
    nameplate?: GiftNameplateItemProps // 铭牌
    star_level?: number // 收藏等级
    cur_gift_cnt?: number // 当前礼物数
    max_gift_cnt?: number // 最大礼物数
    cur_catalog_cnt?: number // 当前图鉴数
    max_catalog_cnt?: number // 最大图鉴数
    cur_star_cnt?: number // 当前星星数
    max_star_cnt?: number // 最大星星数
    // 图鉴列表
    catalog_list?: Array<{
      catalog_id: number
      icon: string
      name: string
    }>
    catalog_id?: number // 当前图鉴id
    cur_catalog_gift_cnt?: number // 当前图鉴礼物数
    max_catalog_gift_cnt?: number // 当前图鉴最大礼物数
    // 图鉴礼物列表
    gift_list?: Array<GiftWallItemProps>
  }
  base: {
    curSortInfo?: {
      type: SortTypeEnum
      idx: number
    }
    curPageStatus?: PageStatusEnum
  }
}

const initialState: InitialStateType = {
  home: {},
  base: {
    curSortInfo: {type: SortTypeEnum.DefaultSort, idx: 0},
  },
}

export const GiftWallSlice = createSlice({
  name: 'GiftWallSlice',
  initialState,
  reducers: {
    updateCurSortInfo: (state, action: PayloadAction<any>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          curSortInfo: action.payload,
        },
      })
    },
    updateCurPageStatus: (state, action: PayloadAction<PageStatusEnum>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          curPageStatus: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      const {member = {}} = action.payload as any
      Object.assign(state, {
        home: {
          ...action.payload,
          member: {
            avatar: member?.avatar_urls?.origin?.urls[0],
            mid: member?.id,
            name: member?.name,
          },
        },
      })
    })
  },
})
export default GiftWallSlice.reducer
export const GiftWallActions = GiftWallSlice.actions

export const useGiftWallState = () => {
  const data = useSelector((state) => {
    return state.Animal_Peacock
  })
  return data
}
